<div class="workspace">
  <mat-toolbar class="topbar">
    <span class="brand-mark"><mat-icon>compare_arrows</mat-icon></span>
    <span class="brand-title">{{ 'brand.lead' | transloco }} <strong>{{ 'brand.mark' | transloco }}</strong></span>
    <span class="toolbar-spacer"></span>
    <div class="view-switch lang-switch" role="group" [attr.aria-label]="'toolbar.language' | transloco">
      @for (lang of langs; track lang) {
        <button type="button" [class.active]="activeLang() === lang" [attr.aria-pressed]="activeLang() === lang" (click)="setLang(lang)">{{ lang.toUpperCase() }}</button>
      }
    </div>
    <button type="button" mat-stroked-button (click)="logout()">{{ 'login.logout' | transloco }}</button>
  </mat-toolbar>

  <div class="shell">
    <nav class="sidebar" [attr.aria-label]="'nav.sections' | transloco">
      @for (item of sections; track item) {
        <a class="nav-item" [routerLink]="'/' + item" routerLinkActive="active" ariaCurrentWhenActive="page">{{ ('nav.' + item) | transloco }}</a>
      }
    </nav>
    <main>
      @if (store.error(); as message) {
        <mat-card class="error-card" role="alert"><mat-card-content><mat-icon color="warn">error_outline</mat-icon><span>{{ message | transloco }}</span>@if (store.loaded()) { <span>{{ 'errors.stale' | transloco }}</span> }<button mat-button color="warn" (click)="store.retry()" [disabled]="store.loading()">{{ 'errors.retry' | transloco }}</button></mat-card-content></mat-card>
      }
      @if (store.loading() && !store.loaded()) { <div class="loading-state" role="status"><mat-spinner diameter="36"></mat-spinner><span>{{ 'status.loadingConfigs' | transloco }}</span></div> }

      <router-outlet />
    </main>
  </div>
</div>

@if (store.historyTarget(); as target) {
  <app-history-drawer
    [row]="target.row"
    [environment]="target.environment"
    [(renderMode)]="renderMode"
    (closed)="store.closeHistory()"
    (checkout)="store.openCheckout($event)"
  />
}

@if (store.editorOpen() && store.editorTarget(); as target) {
  <app-editor-drawer
    [row]="target.left"
    [rightRow]="target.right"
    [leftEnvironment]="target.leftEnvironment"
    [rightEnvironment]="target.rightEnvironment"
    [lockedRight]="store.checkoutSource()"
    [lockedRightLabel]="store.historyCheckout() ? ('editor.historyVersion' | transloco:{ version: store.historyCheckout()!.version }) : null"
    [(renderMode)]="renderMode"
    (closed)="store.closeEditor()"
    (saved)="store.applySaved($event)"
  />
}
